import { EnabledInstrument } from '../hooks/useInstruments.types';

export type InstrumentCommission = EnabledInstrument['fee'];
